import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommBodySplashIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2.60991 2.21982C2.27393 2.21982 2 1.94591 2 1.60991C2 1.27391 2.27391 1 2.60991 1C2.94589 1 3.21982 1.27391 3.21982 1.60991C3.21982 1.94591 2.94591 2.21982 2.60991 2.21982ZM2.59754 1.60991C2.59754 1.6162 2.60383 1.62228 2.60991 1.62228L2.59754 1.60991Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M7.4821 4.8331C7.14612 4.8331 6.87219 4.55919 6.87219 4.22319C6.87219 3.88719 7.1461 3.61328 7.4821 3.61328C7.8181 3.61328 8.09201 3.88719 8.09201 4.22319C8.09201 4.55919 7.8181 4.8331 7.4821 4.8331Z"
            fill="#222"
          />
          <path
            d="M2 4.22319C2 4.55919 2.27393 4.8331 2.60991 4.8331 2.94591 4.8331 3.21982 4.55919 3.21982 4.22319 3.21982 3.88719 2.94589 3.61328 2.60991 3.61328 2.27391 3.61328 2 3.88719 2 4.22319zM2.59754 4.22319C2.59754 4.22948 2.60383 4.23556 2.60991 4.23556L2.59754 4.22319zM2.60991 7.44735C2.27393 7.44735 2 7.17345 2 6.83745 2 6.50144 2.27391 6.22754 2.60991 6.22754 2.94589 6.22754 3.21982 6.50144 3.21982 6.83745 3.21982 7.17364 2.94591 7.44735 2.60991 7.44735zM2.59754 6.83445C2.59754 6.84074 2.60383 6.84682 2.60991 6.84682L2.59754 6.83445zM4.43567 2.91655C4.43567 3.25255 4.7096 3.52646 5.04558 3.52646 5.38158 3.52646 5.65548 3.25255 5.65548 2.91655 5.65548 2.58055 5.38158 2.30664 5.04558 2.30664 4.70957 2.30664 4.43567 2.58055 4.43567 2.91655zM5.0332 2.91655C5.0332 2.92284 5.0395 2.92892 5.04558 2.92892L5.0332 2.91655zM5.04558 6.13974C4.7096 6.13974 4.43567 5.86583 4.43567 5.52983 4.43567 5.19385 4.70957 4.91992 5.04558 4.91992 5.38158 4.91992 5.65548 5.19383 5.65548 5.52983 5.65548 5.86581 5.38158 6.13974 5.04558 6.13974zM5.0332 5.52983C5.0332 5.53612 5.0395 5.5422 5.04558 5.5422L5.0332 5.52983zM10 2.25C9.58579 2.25 9.25 2.58579 9.25 3V5.25H9C8.58579 5.25 8.25 5.58579 8.25 6V8H8C6.89543 8 6 8.89543 6 10V22C6 23.1046 6.89543 24 8 24H16C17.1046 24 18 23.1046 18 22V10C18 8.89543 17.1046 8 16 8H15.75V6C15.75 5.58579 15.4142 5.25 15 5.25H14.75V3C14.75 2.58579 14.4142 2.25 14 2.25H10zM13.25 5.25V3.75H10.75V5.25H13.25zM14.25 8V6.75H9.75V8H14.25zM8 22.5H16C16.2761 22.5 16.5 22.2761 16.5 22V10C16.5 9.72386 16.2761 9.5 16 9.5H8C7.72386 9.5 7.5 9.72386 7.5 10V22C7.5 22.2761 7.72386 22.5 8 22.5z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
